/** Genetics settings: the association and member number registration batches and EPD comparisons start from. */
import { useState } from "react";
import { Link } from "react-router";
import { api } from "../../../web/lib/api";
import { t, useLanguage } from "../../../web/lib/i18n";
import { invalidateAll } from "../../../web/lib/query";
import { useCan, useMe } from "../../../web/lib/session";
import { Button, Card, Field, Section, TextInput, toast } from "../../../web/ui/kit";

interface GeneticsSettingsValue { association?: string; membership?: string; herd_prefix?: string }

export function GeneticsSettings() {
  useLanguage();
  const can = useCan();
  const { data: me } = useMe();
  const current = (me?.ranch?.settings.genetics as GeneticsSettingsValue | undefined) ?? {};
  const [v, setV] = useState<GeneticsSettingsValue>(current);
  const [busy, setBusy] = useState(false);
  if (!me?.ranch) return null;
  const save = async () => {
    setBusy(true);
    try {
      await api.patch("/ranch", { settings: { genetics: { association: v.association?.trim() || undefined, membership: v.membership?.trim() || undefined, herd_prefix: v.herd_prefix?.trim() || undefined } } });
      await invalidateAll();
      toast(t("Saved"), { tone: "good" });
    } finally { setBusy(false); }
  };
  return (
    <Section title={t("Genetics and registration")} hint={t("Used to start registration batches and EPD comparisons.")}>
      <Card>
        <form onSubmit={(e) => { e.preventDefault(); void save(); }}>
          <Field label={t("Main association")} optional><TextInput value={v.association ?? ""} disabled={!can("manage")} onChange={(e) => setV({ ...v, association: e.target.value })} placeholder={"Red Angus Association of America"} /></Field>
          <Field label={t("Member number")} optional><TextInput value={v.membership ?? ""} disabled={!can("manage")} onChange={(e) => setV({ ...v, membership: e.target.value })} className="mono" /></Field>
          <Field label={t("Herd prefix")} optional><TextInput value={v.herd_prefix ?? ""} disabled={!can("manage")} onChange={(e) => setV({ ...v, herd_prefix: e.target.value })} className="mono" /></Field>
          {can("manage") && <div className="form-actions"><Button variant="primary" type="submit" busy={busy}>{t("Save")}</Button><Link to="/work/genetics/traits" className="link">{t("Trait definitions")}</Link></div>}
        </form>
      </Card>
    </Section>
  );
}
